import { PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environment';
import { getPortalModeUrl } from '../portalMode';
import { B2C_CLIENT_ID, B2C_TENANT_URL, b2cPolicies } from './adb2cConfig';
const redirectOrigin = process.env.AUTH_REDIRECT_ORIGIN || window.location.origin;
// Config needs to be dynamic so we can update the policy and instantiate it with a different authority so we can redirect to different policy pages.
const config = () => {
    const configObj = {
        auth: {
            clientId: B2C_CLIENT_ID,
            authority: `${B2C_TENANT_URL}/${b2cPolicies.names.login}`,
            knownAuthorities: [
                `${B2C_TENANT_URL}`,
                `${b2cPolicies.authorities.Signup.authority}`,
                `${b2cPolicies.authorities.SignupSignin.authority}`,
                `${b2cPolicies.authorities.PasswordReset.authority}`,
            ],
            redirectUri: `${redirectOrigin}`,
            postLogoutRedirectUri: `${getPortalModeUrl(environment.employeeFrontendUrl)}`,
        },
    };
    return configObj;
};
export const msalInstance = new PublicClientApplication(config());
